import { api } from "@/lib/api";

export const isIOS = () => {
  const ua = navigator.userAgent || "";
  return /iphone|ipad|ipod/i.test(ua) || (/macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
};

// iOS can't download blobs: open the tab right away (avoids popup blocking), then point it to a short-lived PDF link
export const openAssessmentPdfIOS = async (idOrGetter) => {
  const win = window.open("", "_blank");
  try {
    const id = typeof idOrGetter === "function" ? await idOrGetter() : idOrGetter;
    if (!id) { if (win) win.close(); return; }
    const { data } = await api.post(`/assessments/${id}/pdf-link`);
    const url = `${process.env.REACT_APP_BACKEND_URL}${data.url}`;
    if (win) win.location.href = url;
    else window.location.href = url;
  } catch (e) {
    if (win) win.close();
    throw e;
  }
};
